/* eslint-disable max-len */
import React, { useContext, useEffect } from 'react';
import { withRouter } from 'react-router-dom';
import _ from 'lodash';
import { connect } from 'react-redux';
import withForm from 'modules/common/hoc/withForm';
import Modal from 'modules/common/components/Modal';
import PropTypes from 'prop-types';
import { ModalContext } from 'App';
import * as action from '../action';
import * as c from '../constant';

function UpdateModal({
  setting,
  setFormData,
  formData,
  createInput,
  showSingleSetting,
  updateSetting,
  getSettings,
  history,
  updating,
}) {
  const setModal = useContext(ModalContext);
  
  useEffect(() => {
    setFormData({
      max_pending_applications: _.get(setting, 'attributes.max_pending_applications'),
    })
  }, [setting])
  
  useEffect(() => {
    setFormData({
      max_pending_applications: _.get(setting, 'attributes.max_pending_applications'),
    })
  }, [])

  const handleOnSubmit = (e) => {
    e.preventDefault();
    updateSetting(setting.id, formData, ({ data }) => {
      setModal({ isOpen: false });
      getSettings();
      showSingleSetting(_.get(data, 'id'))
      history.push(`${_.get(data, 'id')}`);
    });
  };

  const closeModal = (e) => {
    e.preventDefault();
    setModal({ isOpen: false });
  };

  return (
    <Modal.Body>
      <form onSubmit={handleOnSubmit}>
        <div className="row">
          <div className="col-12 form-group">
            {createInput(
              { key: 'max_pending_applications', label: 'Max Pending Applications' },
              { required: true }
            )}
          </div>
        </div>
        <div className="d-flex justify-content-center">
          <button
            disabled={updating}
            type="submit"
            className="mt-3 btn btn-primary cms-bg-color-primary cms-outline-primary  mr-3"
          >
            <span className="font-weight-bold">
              {updating ? <i className="fa fa-spin fa-spinner" /> : `Submit`}
            </span>
          </button>
          <button
            disabled={updating}
            type="button"
            onClick={closeModal}
            className="mt-3 btn btn-dark "
          >
            <span className="font-weight-bold">Cancel</span>
          </button>
        </div>
      </form>
    </Modal.Body>
  );
}

UpdateModal.propTypes = {
  setting: PropTypes.instanceOf(Object).isRequired,
  updateSetting: PropTypes.instanceOf(Function).isRequired,
  getSettings: PropTypes.instanceOf(Function).isRequired,
  showSingleSetting: PropTypes.instanceOf(Function).isRequired,
  formData: PropTypes.instanceOf(Object).isRequired,
  history: PropTypes.instanceOf(Object).isRequired,
  setFormData: PropTypes.instanceOf(Function).isRequired,
  createInput: PropTypes.instanceOf(Function).isRequired,
  updating: PropTypes.bool.isRequired,
};

const mapStateToProps = ({ api }) => ({
  setting: _.get(api, `${c.GET_SINGLE_SETTING}.item`) || {},
  
  updating: api.loading.indexOf(c.UPDATE_SETTING) > -1,
});

const enhance = _.flowRight([
  withForm,
  withRouter,
  connect(mapStateToProps, action),
]);

export default enhance(UpdateModal);
